var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceRequestReceiptIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00028 13C8.8021 13 9.57193 13.1365 10.2893 13.3848L9.11356 17.5H7.00028C5.61959 17.5 4.50028 18.6193 4.50028 20C4.50028 20.3559 4.57621 20.6935 4.71024 21H2.00028C1.44802 21 0.994392 20.5507 1.04715 20.001C1.40651 16.2577 3.79618 13 8.00028 13Z",
    fill: "currentColor",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9258 12.2998C22.0876 12.3 22.9266 13.4118 22.6084 14.5293L21.1279 19.7295C20.9136 20.4811 20.2269 20.9999 19.4453 21H6.75C6.33598 20.9998 6.0001 20.664 6 20.25C6 19.8359 6.33591 19.5001 6.75 19.5H10.1338L11.7705 13.752L11.8222 13.5938C12.1134 12.8208 12.856 12.3001 13.6933 12.2998H20.9258Z",
    fill: "currentColor",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 3.5C10.7091 3.5 12.5 5.29086 12.5 7.5C12.5 9.70914 10.7091 11.5 8.5 11.5C6.29098 11.4999 4.5 9.70905 4.5 7.5C4.5 5.29095 6.29098 3.50015 8.5 3.5Z",
    fill: "currentColor",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.501 2C18.7488 2.00035 18.9573 2.18641 18.9853 2.43262C19.1571 3.94882 20.0165 4.87694 21.5556 5.01367C21.8075 5.03605 22.0003 5.24809 22 5.50098C21.9995 5.75364 21.8064 5.96448 21.5547 5.98633C20.0372 6.11768 19.1177 7.03726 18.9863 8.55469C18.9643 8.80638 18.7536 8.99964 18.501 9C18.2482 9.00028 18.0372 8.8074 18.0146 8.55566C17.8779 7.0166 16.9496 6.15621 15.4336 5.98438C15.1873 5.95648 15.0005 5.74874 15 5.50098C14.9997 5.253 15.1863 5.04404 15.4326 5.01563C16.9704 4.83813 17.8382 3.96953 18.0156 2.43164C18.0441 2.18543 18.2531 1.99975 18.501 2Z",
    fill: "currentColor",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceRequestReceiptIcon);
export default __webpack_public_path__ + "static/media/service-request-receipt-icon.cd836b5078e901bdac25d9b4186f524d.svg";
export { ForwardRef as ReactComponent };